// extracted by mini-css-extract-plugin
export default {"mainWrapper":"MainWrapper_mainWrapper__m1XDS","withoutNavigation":"MainWrapper_withoutNavigation__SNvAg","bgGray":"MainWrapper_bgGray__Gy55i"};